<template>
  <div class="switch">
    <span v-if="label" class="text-input mb-2 block">
      {{ label }}
    </span>
    <div class="flex wrapper w-fit">
      <div v-for="option in options" :key="option.value" class="option">
        <input
          :id="`${name}-${option.value}`"
          v-model="value"
          :value="option.value"
          type="radio"
          :name="name"
          class="hidden"
        >
        <label :for="`${name}-${option.value}`" class="w-fit">
          <span class="">{{ option.name }}</span>
        </label>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import { v4 as uuidv4 } from 'uuid';
import {computed} from "vue";

interface Option {
  value: string;
  name: string;
}

interface Props {
  modelValue?: string;
  label?: string;
  options: Option[];
}

const emit = defineEmits(['update:modelValue']);
const props = defineProps<Props>();
const value = useVModel(props, 'modelValue', emit, { passive: true });

const name = uuidv4();
</script>

<style lang="scss" scoped>
.wrapper{
  @apply bg-light-gray;
  @apply rounded-4;
  @apply py-1.5;
}
.option {
  @apply cursor-pointer;
  @apply px-2;

  &:not(:last-of-type){
    @apply border-r-2;
    border-color: #CCCCCC;
  }
}

label{
  @apply cursor-pointer;
  @apply text-table-text-gray;
  @apply px-2;
  @apply py-0.5;
  @apply rounded-4;
  @apply inline-block;
  transition: background var(--speed-fast) ease;
}

input:checked + label {
    @apply bg-success-green;
  @apply text-white;
}
</style>
